import { useEffect, useState } from "react";
import { Link, useRouter } from "@tanstack/react-router";
import { useConfirmEmailChangeMutation } from "@/api/auth";

export function ConfirmEmailChangePage() {
  const [token, setToken] = useState("");
  const [done, setDone] = useState(false);
  const router = useRouter();
  const mutation = useConfirmEmailChangeMutation();

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const t = params.get("token");
    if (t) {
      setToken(t);
      mutation.mutate({ token: t }, { onSuccess: () => setDone(true) });
    }
  }, []);

  return (
    <div className="flex min-h-screen items-center justify-center bg-surface">
      <div className="w-full max-w-md p-6">
        <div className="mb-8 text-center">
          <h1 className="text-3xl font-semibold tracking-tight text-ink">
            MotionForge
          </h1>
        </div>

        <div className="rounded-2xl border border-line bg-surface-2 p-6 text-center">
          {!token ? (
            <>
              <p className="text-sm text-danger">
                Missing confirmation token. Open the link from your email.
              </p>
              <Link
                to="/settings"
                className="mt-4 inline-block text-xs text-ink-2 hover:text-ink"
              >
                Back to settings
              </Link>
            </>
          ) : done ? (
            <>
              <h2 className="text-lg font-semibold text-ink">
                Email updated
              </h2>
              <p className="mt-2 text-sm text-ink-2">
                Your account email has been updated. You can now use it for
                password recovery.
              </p>
              <button
                onClick={() => router.navigate({ to: "/settings" })}
                className="mt-4 w-full rounded-lg bg-accent py-2 text-sm font-medium text-accent-fg transition-colors hover:bg-accent-hover"
              >
                Back to settings
              </button>
            </>
          ) : mutation.isPending ? (
            <p className="text-sm text-ink-2">Confirming…</p>
          ) : mutation.error ? (
            <>
              <h2 className="text-lg font-semibold text-danger">
                Confirmation failed
              </h2>
              <p className="mt-2 text-sm text-ink-2">
                {mutation.error.message}
              </p>
              <Link
                to="/settings"
                className="mt-4 inline-block text-xs text-ink-2 hover:text-ink"
              >
                Try again from settings
              </Link>
            </>
          ) : null}
        </div>
      </div>
    </div>
  );
}
